export var TimezoneType;
(function (TimezoneType) {
    TimezoneType["Europe/Amsterdam"] = "Europe/Amsterdam";
    // GMT = 'GMT',
    // UTC = 'UTC',
    // CET = 'CET',
})(TimezoneType || (TimezoneType = {}));
